// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zbzD","toggle":"styles_toggle__2V_H5","preview":"styles_preview__28m9w"};